// laravel echo
// 使用 NodeJS + Socket.IO 实现的 WebSocket 服务端
import store from '../store';
import Echo from 'laravel-echo';
import { Notification } from 'element-ui';
window.io = require('socket.io-client');

export function scoket (token = '', user = '') {
    console.log('admin_' + user);

    let echo = new Echo({
        broadcaster: 'socket.io',
        // host: window.location.hostname + ':6001',
        host: window.location.host,
        auth: {
            headers: {
                "Api-Token": `${token}`
            }
        }
    });
    // // 监听
    // echo.private('BroadCastChannel').listen('App\Notifications\LoginNotify', function(e) {
    //     console.log(e);
    // });
    // 通知
    echo.private('admin_' + user).notification(function (e) {
        store
            .commit('SET_UNREAD', e.unread || 0);
        if (e.file) {
            Notification({
                type: 'info',
                title: '消息',
                dangerouslyUseHTMLString: true,
                message: `<strong>${e.title}</strong>
                        <p>${e.message}</p>
                        <a href="${e.file
                    }" download class="accessory-download accessory-download-2">
                            <i class="iconfont icon-fujianxiazai"></i>
                            <span>附件下载</span>
                        </a>`,
                duration: 0
            });
        } else {
            Notification({
                type: 'info',
                title: '消息',
                dangerouslyUseHTMLString: true,
                message: `<strong>${e.title}</strong>
                        <p>${e.message}</p>`,
                duration: 0
            });
        }
    });
}

export default { scoket };


// WEBPACK FOOTER //
// ./src/utils/scoket.js